import { InventoryResourceModel } from 'src/app/models/api/inventoryResource.model';
import { ViolationResource } from 'src/app/models/api/violations.model';

export const populateErrorMessage = (resource: InventoryResourceModel | ViolationResource): string => {
  let errorMessage = '';
  if (resource.errorsInfo && resource.errorsInfo.errors.length > 0) {
    resource.errorsInfo.errors.forEach((error) => {
      errorMessage += error.errorMessage + ' ';
    });
  }
  return errorMessage;
};
